<script lang="ts">import "./types";
let { size = "40px", color = "#FFFFFF", speed = "1s" } = $props();
</script>

<div
	class="spinner"
	style="
		--spinner-size: {size};
		--spinner-color: {color};
		--spinner-speed: {speed};
	"
></div>

<style>
	.spinner {
		display: inline-block;
		border: 4px solid transparent;
		border-radius: 50%;
		border-top-color: var(--spinner-color);
		width: var(--spinner-size);
		height: var(--spinner-size);
		animation: spin var(--spinner-speed) linear infinite;
	}

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
</style>
